<div id="whatsapp-chat-widget">
    <div id="wa-widget-send-button">
        <a role="button" target="_blank"
            href="https://api.whatsapp.com/send?phone=919826323332&amp;text= Hello, VocBot.AI Here" title="WhatsApp"
            class="wa-chat-box-content-send-btn">
            <img src="assets/img/Whatsapp.gif" style="height: 70px; min-width: 70px;">
        </a>
        <!-- </div>

    <div id="wa-widget-send-buttons"> -->
        <a role="button" target="_blank" title="Scroll" *ngIf="showBtn$ | async" class="top-btn" (click)="gotoTop()">
            <img src="assets/img/scroll.gif" style="height: 58px; min-width: 58px;">
        </a>
    </div>
</div>